<template>
    <div>
        <router-view v-if="enginesData.hasEngines"></router-view>
        <LoadingView v-else />
        <FormCfgData />
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import LoadingView from '../views/LoadingView.vue'
    import FormCfgData from '../components/TemplateParts/Forms/FormCfgData.vue'
    export default {
        name: 'Parent',
        components: { LoadingView, FormCfgData },
        mounted(){
            this.handleEngines()
        },
        computed:{
            ...mapState(['carsLst', 'enginesData']),
        },
        methods: {
            handleEngines(){
                let currRoute = this.$route.path.split('/')
                if(!this.carsLst.some(el => el.model == currRoute[1])){
                    this.$router.push('/')
                }
                // if(!this.enginesData.hasEngines) this.$store.dispatch('enginesData/fetchEngines')
            },
        }
    }
</script>
